<template>
  <v-container>
    <h1 class="display-1 pt-3">{{ courseName }} Responses</h1>
    <v-breadcrumbs :items="items" class="pa-0 ma-0 mb-2 mt-2"></v-breadcrumbs>

    <a-l-dayresponses class="" :course="course" />
  </v-container>
</template>
<script>
import dayresponses from "../../components/bycourse";
import service from "@/services/index.js";
export default {
  props: ["courseid"],
  components: {
    "a-l-dayresponses": dayresponses
  },
  data: () => ({
    course: null
  }),
  computed: {
    items() {
      return [
        {
          text: "Courses",
          disabled: false,
          to: { name: "responses" },
          link: false,
          exact: true
        },
        {
          text: "Responses by Course",
          disabled: false,
          to: {
            name: "responsesbycourse",
            params: { courseid: this.courseid }
          },
          exact: true
        }
      ];
    },
    courseName() {
      if (!this.course) {
        return "";
      }
      return this.course.name || "";
    }
  },
  methods: {
    async onLoad() {
      this.$store.commit("setLoading", true);
      let course = await service.course.getOne({
        type: "publisher",
        id: this.courseid
      });
      this.$store.commit("setLoading", false);

      this.course = course;
    }
  },
  mounted() {
    this.onLoad();
  }
};
</script>
